export default __webpack_public_path__ + "static/media/add.eb4d7784.svg";